import consola from "consola";

const log: Function =
  process.env.NODE_ENV === "development" ? consola.info : () => {};

export default log;
